import { Download } from "@mui/icons-material"
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography } from "@mui/material"
import moment from "moment"
import { useContext, useRef, useState } from "react"
import { renderToStaticMarkup, renderToString } from "react-dom/server"
import { AppContext } from "../../AppContext"
import $data from "../../services/$data"
import { variables } from "../../styles/abstract/variables"
import { DataContext } from "../DataContext"

const tableStyle = {
  pageBreakInside: 'auto',
  width: '100%',
  borderSpacing: 0, borderCollapse: "collapse",
  margin: '30px auto 30px auto',

}

const thStyle = {
  fontWeight: 'bold',
  padding: '10px',
  textAlign: 'center',
  border: '1px solid #555',
  color: variables.primary
}

const tdStyle = {
  padding: '7px',
  fontSize: '12px',
  border: '1px solid #555',
  // textTransform: 'uppercase',
  pageBreakInside: 'avoid', pageBreakAfter: 'auto' 
}

const trStyle = {
  pageBreakInside: 'avoid', pageBreakAfter: 'auto' 
}

const theadStyle = {
  display:'table-header-group'
}

const itemStyle = {
  padding: '15px',
  pageBreakInside: 'avoid',
  pageBreakAfter: 'always'

}

function ApplicabilityTemplate(props) {
  const {user} = useContext(AppContext);
  const {projects} = useContext(DataContext);

  const downloadRef = useRef(null);

  const [loading, setLoading] = useState(false);

  const downloadPDF = () => {
    setLoading(true);
    const htmlString = renderToStaticMarkup(renderContent());
    $data.downloadPDF(`<!DOCTYPE html><html><head><style>
    
      table {
        page-break-inside: avoid;
      }
      thead {
        display: table-header-group;
      }

      tr {
        # LABYY 
      }
    
  </style></head><body>${htmlString}</body><html>`)
      .then((data) => {
        downloadRef.current.href = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }));
        downloadRef.current.download = 'applicability.pdf';
        downloadRef.current.click();
        window.URL.revokeObjectURL(downloadRef.current.href);
        setLoading(false);

      })
      .catch(err => {
        setLoading(false);
        console.log(err);
      })
  }

  const renderContent = () => {
    try {
      return (
        <div style={{ fontFamily: 'sans-serif', margin: '10px 20px' }}>
          <div style={{ textAlign: 'center' }}>
            <img width="400" src="data:image/svg+xml;base64,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" />
          </div>
          <h2 style={{ textAlign: 'center', color: variables.primary }}>Report on parcels applicability</h2>
          <hr />
          {renderTables()}
        </div>
      )
    } catch (error) {
      console.log(error)
      return <Typography color="error" variant="body1">Something went wrong with the applicability report</Typography>
    }
    
  }

  const renderWorldCover = (world_years, parcels) => {
    try {

      return (
        <div style={itemStyle}>
          <div>
            <p>Applicability parameter: <strong style={{ color: variables.primary }}>Cropland/grassland status</strong></p>
            <p>Method for verification: <strong style={{color: variables.primary}}>World Cover</strong></p>
          </div>

          <table style={tableStyle}>
            <thead style={theadStyle}>
              <tr>
                <td rowSpan={2} style={thStyle}>Parcel</td>
                <td colSpan={world_years.length} style={thStyle}>Land cover status per year</td>
                <td style={thStyle} rowSpan={2}>Compliance</td>
              </tr>
              <tr>
                {world_years.map((year, key) => {
                  return <td key={key} style={thStyle}>{year}</td>
                })}
                 {/* <td style={thStyle}></td> */}
              </tr>
            </thead>
            <tbody>
              {console.log('WORLD')}
              {parcels.map((parcel, key) => {
                return (
                  <tr key={key} style={trStyle}>
                    <td style={tdStyle}>{Object.values(parcel)[0]}</td>
                    {world_years.map((year, j) => {
                      let yearObj = parcel.values[0]['World Cover'][year];
                      let classes;
                      try {
                        classes = yearObj.dominant_class.split(';');
                      } catch(e) {
                        classes = []
                      }
                      console.log(classes)
                      return <td key={j} style={{...tdStyle, color: yearObj.status === false ? 'red' : '#333'}}>{classes.map((v,ind) => <p key={ind}>{v}</p>)}</td>
                    })}
                    <td style={{...tdStyle, fontWeight: 'bold', color: parcel.values[0]['World Cover'].compliance_status ? 'green' : 'red'}}>
                      {parcel.values[0]['World Cover'].compliance_message}
                    </td>
                  </tr>
                )
              })}
            </tbody>
            <tbody>

            </tbody>
          </table>

        </div>
      )

    } catch (e) {
      console.log('WORLD COVER ERROR =>');
      console.log(e);
      console.log('========================');
      return (
      <div>
        <p><strong>Something went wrong with World Cover report</strong></p>
      </div>
    )
    }
  }

  const renderLandCoverUK = (lcuk_years, parcels) => {
    try {
      if(!lcuk_years) return null;

      if(lcuk_years.length === 0) return null;

      return (
        <div style={itemStyle}>
          <div>
            <p>Applicability parameter: <strong style={{ color: variables.primary }}>Cropland/grassland status</strong></p>
            <p>Method for verification: <strong style={{color: variables.primary}}>Land Cover Map for Great Britain</strong></p>
          </div>

          <table style={tableStyle}>
            <thead style={theadStyle}>
              <tr>
                <td rowSpan={2} style={thStyle}>Parcel</td>
                <td colSpan={lcuk_years.length} style={thStyle}>Land cover status per year</td>
                <td style={thStyle} rowSpan={2}>Compliance</td>
              </tr>
              <tr>
                {lcuk_years.map((year, key) => {
                  return <td key={key} style={thStyle}>{year}</td>
                })}
                 {/* <td style={thStyle}></td> */}
              </tr>
            </thead>
            <tbody>
              {parcels.map((parcel, key) => {
                return (
                  <tr key={key} style={trStyle}>
                    <td style={tdStyle}>{Object.values(parcel)[0]}</td>
                    {lcuk_years.map((year, j) => {
                      let yearObj = parcel.values[0]['Land Cover Map for Great Britain'][year];
                      if(!yearObj || yearObj === 'Missing data') {
                        return <td key={j} style={{...tdStyle, color: 'red'}}>{'Missing data'}</td>

                      }
                      let classes;
                      try {
                        classes = yearObj.dominant_class.split(';');
                      } catch(e) {
                        classes = []
                      }

                      return <td key={j} style={{...tdStyle, color: yearObj.status === false ? 'red' : '#333'}}>{classes.map((v,ind) => <p key={ind}>{v}</p>)}</td>
                    })}
                    
                    {lcuk_years.length === 0 ? <td colSpan="2" style={{...tdStyle, fontWeight: 'bold', color: 'red'}}>
                      {'Missing data'}
                    </td> : <td style={{...tdStyle, fontWeight: 'bold', color: parcel.values[0]['Land Cover Map for Great Britain'].compliance_status ? 'green' : 'red'}}>
                      {parcel.values[0]['Land Cover Map for Great Britain'].compliance_message}
                    </td>}
                    
                  </tr>
                )
              })}
            </tbody>
            <tbody>

            </tbody>
          </table>

        </div>
      )

    } catch (e) {
      console.log('LAND COVER UK ERROR =>');
      console.log(e);
      console.log('========================');
      return (
      <div>
        <p><strong>Something went wrong with Land Cover UK report</strong></p>
      </div>
    )
    }
  }

  const renderLandCoverIreland = (i_years, parcels) => {
    try {
      if(!i_years) return null;

      if(i_years.length === 0) return null;

      return (
        <div style={itemStyle}>
          <div>
            <p>Applicability parameter: <strong style={{ color: variables.primary }}>Cropland/grassland status</strong></p>
            <p>Method for verification: <strong style={{color: variables.primary}}>Land Cover Map for Ireland</strong></p>
          </div>

          <table style={tableStyle}>
            <thead style={theadStyle}>
              <tr>
                <td rowSpan={2} style={thStyle}>Parcel</td>
                <td colSpan={i_years.length} style={thStyle}>Land cover status per year</td>
                <td style={thStyle} rowSpan={2}>Compliance</td>
              </tr>
              <tr>
                {i_years.map((year, key) => {
                  return <td key={key} style={thStyle}>{year}</td>
                })}
                 {/* <td style={thStyle}></td> */}
              </tr>
            </thead>
            <tbody>
              {parcels.map((parcel, key) => {
                return (
                  <tr key={key} style={trStyle}>
                    <td style={tdStyle}>{Object.values(parcel)[0]}</td>
                    {i_years.map((year, j) => {
                      let yearObj = parcel.values[0]['Land Cover Map for Ireland'][year];
                      if(!yearObj || yearObj === 'Missing data') {
                        return <td key={j} style={{...tdStyle, color: 'red'}}>{'Missing data'}</td>

                      }
                      let classes;
                      try {
                        classes = yearObj.dominant_class.split(';');
                      } catch(e) {
                        classes = []
                      }
                      return <td key={j} style={{...tdStyle, color: yearObj.status === false ? 'red' : '#333'}}>{classes.map((v,ind) => <p key={ind}>{v}</p>)}</td>
                    })}
                    
                    {i_years.length === 0 ? <td colSpan="2" style={{...tdStyle, fontWeight: 'bold', color: 'red'}}>
                      {'Missing data'}
                    </td> : <td style={{...tdStyle, fontWeight: 'bold', color: parcel.values[0]['Land Cover Map for Ireland'].compliance_status ? 'green' : 'red'}}>
                      {parcel.values[0]['Land Cover Map for Ireland'].compliance_message}
                    </td>}
                    
                  </tr>
                )
              })}
            </tbody>
            <tbody>

            </tbody>
          </table>

        </div>
      )

    } catch (e) {
      console.log('LAND COVER UK ERROR =>');
      console.log(e);
      console.log('========================');
      return (
      <div>
        <p><strong>Something went wrong with Land Cover Ireland report</strong></p>
      </div>
    )
    }
  }

  const renderCorine = (corine_years, parcels) => {
    try {

      return (
        <div style={itemStyle}>
          <div>
            <p>Applicability parameter: <strong style={{ color: variables.primary }}>Cropland/grassland status</strong></p>
            <p>Method for verification: <strong style={{color: variables.primary}}>Corine Land Cover</strong></p>
          </div>

          <table style={tableStyle}>
            <thead style={theadStyle}>
              <tr>
                <td rowSpan={2} style={thStyle}>Parcel</td>
                <td colSpan={corine_years.length} style={thStyle}>Land cover status per year</td>
                <td style={thStyle} rowSpan={2}>Compliance</td>
              </tr>
              <tr>
                {corine_years.map((year, key) => {
                  return <td key={key} style={thStyle}>{year}</td>
                })}
                 {/* <td style={thStyle}></td> */}
              </tr>
            </thead>
            <tbody>
              {parcels.map((parcel, key) => {
                return (
                  <tr key={key} style={trStyle}>
                    <td style={tdStyle}>{Object.values(parcel)[0]}</td>
                    {corine_years.map((year, j) => {

                      let yearObj = parcel.values[0]['Corine Land Cover'][year];
                  

                      if(!yearObj) {
                        return (
                          <td key={j} style={{...tdStyle, color: 'red'}}>{'Missing data'}</td>
                        ) 
                      }
                      let classes;
                      try {
                        classes = yearObj.dominant_class.split(';');
                      } catch(e) {
                        classes = []
                      }

                      return <td key={j} style={{...tdStyle, color: yearObj.status === false ? 'red' : '#333'}}>{classes.map((v,ind) => <p key={ind}>{v}</p>)}</td>
                    })}
                    <td style={{...tdStyle, fontWeight: 'bold', color: parcel.values[0]['Corine Land Cover'].compliance_status ? 'green' : 'red'}}>
                      {parcel.values[0]['Corine Land Cover'].compliance_message}
                    </td>
                  </tr>
                )
              })}
            </tbody>
            <tbody>

            </tbody>
          </table>

        </div>
      )

    } catch (e) {
      console.log('CORINE ERROR =>');
      console.log(e);
      console.log('========================');
      return (
      <div>
        <p><strong>Something went wrong with Corine Land Cover report</strong></p>
      </div>
    )
    }
  }

  const renderPlough = (p_years, parcels) => {
    try {
      if(!p_years) return null;

      if(p_years.length === 0) return null;

      return (
        <div style={itemStyle}>
          <div>
            <p>Applicability parameter: <strong style={{ color: variables.primary }}>Ploughing status</strong></p>
            <p>Method for verification: <strong style={{color: variables.primary}}>COPERNICUS Land monitoring service - Ploughing </strong></p>
          </div>

          <table style={tableStyle}>
            <thead style={theadStyle}>
              <tr>
                <td rowSpan={2} style={thStyle}>Parcel</td>
                <td colSpan={p_years.length} style={thStyle}>Is ploughing detected in previous 5 years (before 2018)</td>
                <td style={thStyle} rowSpan={2}>Compliance</td>
              </tr>
              <tr>
                {p_years.map((year, key) => {
                  return <td key={key} style={thStyle}>{year}</td>
                })}
                 {/* <td style={thStyle}></td> */}
              </tr>
            </thead>
            <tbody>
              {parcels.map((parcel, key) => {
                return (
                  <tr key={key} style={trStyle}>
                    <td style={tdStyle}>{Object.values(parcel)[0]}</td>
                    {p_years.map((year, j) => {
                      let yearObj = parcel.values[0]['Plough'][year];
                      if(!yearObj || yearObj === 'Missing data') {
                        return <td key={j} style={{...tdStyle, color: 'red'}}>{'Missing data'}</td>

                      }
                      return <td key={j} style={{...tdStyle, color: yearObj.status === false ? 'red' : '#333'}}>{yearObj.dominant_class.split(';').map(v => <p>{v}</p>)}</td>
                    })}
                    
                    {p_years.length === 0 ? <td colSpan="2" style={{...tdStyle, fontWeight: 'bold', color: 'red'}}>
                      {'Missing data'}
                    </td> : <td style={{...tdStyle, fontWeight: 'bold', color: parcel.values[0]['Plough'].compliance_status ? 'green' : 'red'}}>
                      {parcel.values[0]['Plough'].compliance_message}
                    </td>}
                    
                  </tr>
                )
              })}
            </tbody>
            <tbody>

            </tbody>
          </table>

        </div>
      )

    } catch (e) {
      console.log('LAND COVER UK ERROR =>');
      console.log(e);
      console.log('========================');
      return (
      <div>
        <p><strong>Something went wrong with Ploughing report</strong></p>
      </div>
    )
    }
  }


  const isUK = () => {
    if(user.user_type === 3) {
      let pr = projects.results.filter(p => p.getId().toString() === props.projectId)[0];

      if(!pr.country) return false;

      return pr.country.indexOf(1) > -1
    }

    if(user.user_type === 1) {
      return user.country === "1";
    }

    return false
  }

  const isIreland = () => {
    if(user.user_type === 3) {
      let pr = projects.results.filter(p => p.getId().toString() === props.projectId)[0];

      if(!pr.country) return false;
      

      return pr.country.indexOf(6) > -1
    }

    if(user.user_type === 1) {
      return user.country === "6"
    }

    return false
  }

  const renderTables = () => {

    if(!props.data) return (
      <p>Error occured while trying to display the report content. Please contact our technical support.</p>
    )

    if(props.data.length === 0) return (
      <p>There are no parcels created. Please create/import parcels before trying to generate a report.</p>
    )

    // return DUMMY.map((obj, key) => {
      let vals = Object.values(props.data[0]);
    //   let parcel = vals[0];
      let item = vals[1][0];

      let corine_years = Object.keys(item['Corine Land Cover']).filter((name) => name !== 'compliance_status' && name !== 'compliance_message' && name !== 'dominant_class' && name !== 'status')
      let world_years = Object.keys(item['World Cover']).filter((name) => name !== 'compliance_status' && name !== 'compliance_message')
      let lcuk_years = Object.keys(item['Land Cover Map for Great Britain']).filter((name) => name !== 'compliance_status' && name !== 'compliance_message' && name !== 'dominant_class' && name !== 'status')
      let p_years = Object.keys(item['Plough']).filter((name) => name !== 'compliance_status' && name !== 'compliance_message' && name !== 'dominant_class' && name !== 'status')
      let i_years = Object.keys(item['Land Cover Map for Ireland']).filter((name) => name !== 'compliance_status' && name !== 'compliance_message' && name !== 'dominant_class' && name !== 'status')
      let t_years = Object.keys(item['Trees and shrubs']).filter((name) => name !== 'compliance_status' && name !== 'compliance_message')
      let w_years = Object.keys(item['Wetlands']).filter((name) => name !== 'compliance_status' && name !== 'compliance_message')
    //   let values = Object.values(Object.values(item)[0])

      let parcels = Object.values(props.data);


      return (
        <>
        {isUK() && renderLandCoverUK(lcuk_years, parcels)}
        {isIreland() && renderLandCoverIreland(i_years, parcels)}
        {renderWorldCover(world_years, parcels)}

        {renderCorine(corine_years, parcels)}

        {renderPlough(p_years, parcels)}

        

        <div style={itemStyle}>
          <div>
            <p>Applicability parameter: <strong style={{ color: variables.primary }}>Natural vegetation (Trees and shrubs)</strong></p>
            <p>Method for verification: <strong style={{color: variables.primary}}>COPERNICUS land monitoring service - Tree Cover Density</strong></p>
          </div>

          <table style={tableStyle}>
            <thead>
              <tr>
                <td rowSpan={2} style={thStyle}>Parcel</td>
                <td colSpan={t_years.length} style={thStyle}>% of the parcel under trees/shrubs in year</td>
                <td style={thStyle} rowSpan={2}>Compliance</td>
              </tr>
              <tr>
                {t_years.map((year, key) => {
                  return <td key={key} style={thStyle}>{year}</td>
                })}
                 {/* <td style={thStyle}></td> */}
              </tr>
            </thead>
            <tbody>
              {parcels.map((parcel, key) => {
                return (
                  <tr key={key} style={trStyle}>
                    <td style={tdStyle}>{Object.values(parcel)[0]}</td>
                    {t_years.map((year, j) => {
                      let yearObj = parcel.values[0]['Trees and shrubs'][year];

                      let classes;

                      try {
                        classes = yearObj.dominant_class.split(';');
                      } catch(e) {
                        classes = []
                      }

                      return <td key={j} style={{...tdStyle, color: yearObj.status === false ? 'red' : '#333'}}>{classes.map((v, ind) => <p style={{whiteSpace: 'nowrap'}} key={ind}>{v}</p>)}</td>
                    })}
                    <td style={{...tdStyle, fontWeight: 'bold', color: parcel.values[0]['Trees and shrubs'].compliance_status ? 'green' : 'red'}}>
                      {parcel.values[0]['Trees and shrubs'].compliance_message}
                    </td>
                  </tr>
                )
              })}
            </tbody>
            <tbody>

            </tbody>
          </table>

        </div>

        <div style={itemStyle}>
          <div>
            <p>Applicability parameter: <strong style={{ color: variables.primary }}>Wetlands</strong></p>
            <p>Method for verification: <strong style={{color: variables.primary}}>COPERNICUS land monitoring service – Water and wetness</strong></p>
          </div>

          <table style={tableStyle}>
            <thead>
              <tr>
                <td rowSpan={2} style={thStyle}>Parcel</td>
                <td colSpan={w_years.length} style={thStyle}>% of the parcel under water/wetlands in year</td>
                <td style={thStyle} rowSpan={2}>Compliance</td>
              </tr>
              <tr>
                {w_years.map((year, key) => {
                  return <td key={key} style={thStyle}>{year}</td>
                })}
                 {/* <td style={thStyle}></td> */}
              </tr>
            </thead>
            <tbody>
              {parcels.map((parcel, key) => {
                return (
                  <tr key={key} style={trStyle}>
                    <td style={tdStyle}>{Object.values(parcel)[0]}</td>
                    {w_years.map((year, j) => {
                      let yearObj = parcel.values[0]['Wetlands'][year];
                      return <td key={j} style={{...tdStyle, color: yearObj.status === false ? 'red' : '#333'}}>{yearObj?.dominant_class || ' - '}</td>
                    })}
                    <td style={{...tdStyle, fontWeight: 'bold', color: parcel.values[0]['Wetlands'].compliance_status ? 'green' : 'red'}}>
                      {parcel.values[0]['Wetlands'].compliance_message}
                    </td>
                  </tr>
                )
              })}
            </tbody>
            <tbody>

            </tbody>
          </table>

        </div>
        </>
      )
  }

  return <Dialog PaperProps={{ className: 'co-background-white' }} fullWidth maxWidth="xl" open={props.open} onClose={props.onClose}>
    <DialogTitle color="primary">Applicability report</DialogTitle>
    <DialogContent>
    {loading && <LinearProgress color="primary" />}

      {renderContent()}
      <a ref={downloadRef}></a>

    </DialogContent>
    <DialogActions>
      <Button variant="contained" disabled={loading} onClick={downloadPDF} style={{ lineHeight: 'unset' }} color="primary" startIcon={<Download />}>Download PDF</Button>
      <Button variant="contained" disabled={loading} onClick={props.onClose} style={{ lineHeight: 'unset' }} color="error">Close</Button>
      
    </DialogActions>

  </Dialog>
}

export default ApplicabilityTemplate;